let MessagePreprocessor = require('./messagepreprocessor');
let Settings = require('../settings');

let Messages = {
	cozy: require('./messages/cozy'),
	compact: require('./messages/compact'),
};

let Message = {
	format(room, fmt){
		if (fmt instanceof Array){
			return this.formatByArray(room, fmt);
		}

		return this.formatByObject(room, fmt);
	},

	formatByArray(room, fmt){
		let $p = $('<div class="chat-msg"/>');
		for (let i = 0; i < fmt.length; i += 2){
			let $el = $('<span/>');
			let color = fmt[i];
			let msg = fmt[i+1];

			let isSysMessage = color[0] == '+';
			if (isSysMessage){
				color = color.substr(1);
			}

			if (color == '@'){
				$el.html(msg);
			}
			else {
				if (color != ''){
					$el.css({color: color});
				}

				if (isSysMessage){
					$el.html(MessagePreprocessor.preprocessSysMessageText(room, msg));
				} else {
					$el.html(MessagePreprocessor.preprocessMessageText(room, msg));
				}
			}

			$p.append($el);
		}

		return $p;
	},

	formatByObject(room, fmt){
		let style = Settings.messagesStyle;
		if (Messages[style] === undefined){
			style = 'cozy';
		}

		let m = Messages[style];
		let f = m[fmt.type];
		if (f instanceof Function){
			let $res = f.call(m, room, fmt);
			$res.addClass('chat-style-' + style);
			$res.find('.chat-msg-time').attr('title', 'Цитировать');
			return $res;
		}

		return null;
	},
};

module.exports = Message;
